import {getElement, removeActive} from "./helpers.js";
import smoothHeight from "./smoothHeight.js";

export default function checkout() {
    if (!getElement('.checkout')) return


    radioButtonItem();
    getElement('[data-summary]').addEventListener('click', function () {
        this.classList.toggle('active');
        document.body.classList.toggle('no-scroll');
        getElement('.cart').classList.toggle('active');
        // setTimeout(() => {
            getElement('.checkout').classList.toggle('active');
        // }, 200)

    })


}

function radioButtonItem() {
    if (!getElement('.radio', true)) return;
    getElement('.radio', true).forEach(item => {
        item.querySelectorAll('.radio__item').forEach(itemRadio => {
            itemRadio.addEventListener('click', function () {
                if (item.dataset.payment) {
                    item.dataset.payment = itemRadio.dataset.payment
                }
                if (item.dataset.installment) {
                    item.dataset.installment = itemRadio.dataset.installment
                }
                if (itemRadio.classList.contains('active')) {
                    itemRadio.classList.remove('active');
                    if (item.dataset.payment) {
                        item.dataset.payment = 'false';
                    }
                    if (item.dataset.installment) {
                        item.dataset.installment = 'false';
                    }
                }
                ;
                removeActive(item.querySelectorAll('.radio__item'));
                if (itemRadio.parentElement.dataset.open === 'true') {
                    itemRadio.parentElement.dataset.open = 'false';
                    itemRadio.nextElementSibling.style.maxHeight = "";
                    setTimeout(() => {
                        itemRadio.parentElement.classList.remove("active");
                    }, 300)

                    return;
                }
                item.querySelectorAll('.radio__item').forEach(el => {
                    if (el.parentElement.dataset.open === 'true' && itemRadio !== el) {
                        el.parentElement.dataset.open = 'false';
                        el.nextElementSibling.style.maxHeight = "";
                        setTimeout(() => {
                            el.classList.remove("active");
                            el.parentElement.classList.remove("active");
                        }, 300)
                    }

                })

                itemRadio.classList.add('active')
                if (itemRadio.dataset.payment === 'card') {

                    if (itemRadio.parentElement.dataset.open !== "true") {
                        itemRadio.parentElement.dataset.open = "true";
                        itemRadio.nextElementSibling.style.maxHeight = `${itemRadio.nextElementSibling.scrollHeight}px`;
                        itemRadio.classList.add("active");
                        itemRadio.parentElement.classList.add("active");
                    } else {
                        itemRadio.parentElement.dataset.open = "false";
                        itemRadio.nextElementSibling.style.maxHeight = "";
                        setTimeout(() => {
                            itemRadio.classList.remove("active");
                            itemRadio.parentElement.classList.remove("active");
                        }, 300)
                    }


                }


            })


        })

    });
};